<template>
	<v-snackbar v-model="snackbar.show" :color="snackbar.type" :timeout="snackbar.timeout">
		{{ snackbar.text }}
		<template v-slot:action="{ attrs }">
			<v-btn
				text
				v-bind="attrs"
				@click="snackbar.show = false"
			>
				ok
			</v-btn>
		</template>
	</v-snackbar>
</template>

<script>
import { EventBus } from "@/main";

export default {
	name: "Snackbar",

	data() {
		return {
			snackbar: {
				text: null,
				show: false,
				type: null,
				timeout: 1500,
			},
		};
	},
	created() {
		EventBus.$on("Snackbar", (conf) => {
			this.snackbar = {
				text: conf.text ? conf.text : null,
				type: conf.type ? conf.type : null,
				timeout: conf.timeout ? conf.timeout : 1500,
				show: true,
			}
		});
	},
};
</script>

<style lang="css" scoped></style>
